var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.renderStart
    ? _c(
        "div",
        {
          ref: "app",
          class: { defaultApp: !_vm.configValid },
          attrs: { id: "app" }
        },
        [
          _c("div", { staticClass: "wrap-left" }),
          _c("router-view"),
          _c("div", { staticClass: "foot-tip" }, [
            _vm._v(" 如遇问题请联系客服 400-608-9666 ")
          ]),
          _c("el-image", {
            staticStyle: { display: "none" },
            attrs: { fit: "scale-down", src: _vm.appConfig.backgroundUrl },
            on: { load: _vm.handleImgLoad, error: _vm.handleImgError }
          })
        ],
        1
      )
    : _c("div", { staticClass: "check-load" }, [
        _vm._m(0),
        _c("div", { staticClass: "load-txt" }, [_vm._v("SSO登录检查中...")])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load-wrap" }, [
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }